import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button
} from '@chakra-ui/react';

import { ChevronDownIcon } from '@chakra-ui/icons';

import Const from '../Constants';

import { useEpicsStore } from '../Stores/EpicsStore';
import { useEffect, useState } from 'react';

const EpicSelector = ({ currentEpicId, onChange }) => {
  const epics = useEpicsStore((state) => state.epics);

  const [currentEpic, setCurrentEpic] = useState(null);

  useEffect(() => {
    if (currentEpicId) {
      const epic = epics.find(epic => epic.id === currentEpicId);
      setCurrentEpic(epic);
    } else {
      setCurrentEpic(null);
    }
  }, [currentEpicId, epics]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        width="40"
        size={Const.SM}
        bg={currentEpic ? currentEpic.color : Const.Gray46}
        color={Const.White}
        borderRadius="md"
        border="1px solid"
        borderColor={Const.Gray100}
        textAlign="left"
        _hover={{ bg: Const.Gray69 }}
        _focus={{ boxShadow: 'none' }}
        _expanded={{ bg: currentEpic ? currentEpic.color : Const.Gray46 }}
      >
        {currentEpic ? currentEpic.title : '-'}
      </MenuButton>
      <MenuList borderRadius={0} bg='transparent' padding={0} margin={0} borderColor={Const.Gray180}>
        {epics.map((epic) => (
          <MenuItem
            key={epic.id}
            onClick={() => {
              setCurrentEpic(epic);

              onChange(epic.id);
            }}
            bg={epic.color}
            _hover={{ bg: Const.Gray69 }}
            color={Const.White}
            fontSize={Const.SM}
          >
            {epic.title}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default EpicSelector;
